import React, { useEffect } from 'react'
import InnerHTML from 'dangerously-set-html-content'
import PlaceHolderImage from 'components/PlaceholderImage'
import ReactCompareImage from 'steps/shared/ReactCompareImage'

export const BodyCopy = ({ bodyCopy, order }) => {
  if (!bodyCopy) return null

  // The editorial team hard-coded some sign-up copy in many/most articles. This removes it.
  let tmp = '' + bodyCopy
  const reg = /(\bNot a member\b(.*)\bfamily and friends\b\!)/
  tmp = tmp.replace(reg, '')

  return (
    <div
      className="content-item body-copy step-subcopy"
      style={{ order: order }}
      dangerouslySetInnerHTML={{ __html: tmp }}
    />
  )
}

export const Button = ({ url, bgColor, buttonText, order, onClick }) => {
  return (
    <div className="content-item button">
      <a
        href={url}
        style={{
          background: bgColor,
          color: '#fff',
          order: order,
        }}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        {buttonText}
      </a>
    </div>
  )
}

export const EmbedCode = ({ embedCode, order }) => {
  useEffect(() => {
    // triggers instagram's library to look for posts to embed
    // needed when an instagram embed isn't on the page when the instagram library loads initially
    window &&
      window.instgrm &&
      window.instgrm.Embeds &&
      window.instgrm.Embeds.process()
  }, [embedCode])

  return (
    embedCode ? 
      <div className="content-item embed" style={{ order: order }}>
        <InnerHTML key={embedCode} html={embedCode} />
      </div>
      : 
      ""
  )
}
export const Image = ({ image, order }) => {
  return (
    <div className="content-item image-contain" style={{ order: order }}>
      {image && image.id && (
        <PlaceHolderImage
          src={`${process.env.SITE_ASSET_URL}/${image.id}`}
          height={745}
          width={745}
          alt={image.altAttribute || image.name || ''}
        />
      )}
    </div>
  )
}

export const ImageComparison = ({ leftImageUrl, rightImageUrl, order }) => {
  return (
    <div className="content-item image-compare" style={{ order: order }}>
      <ReactCompareImage leftImage={leftImageUrl} rightImage={rightImageUrl} />
    </div>
  )
}

export const OldBodyCopy = ({ content, order }) => {
  return (
    <div className="content-item old-body-copy" style={{ order: order }}>
      <InnerHTML html={content} />
    </div>
  )
}
